import React from "react";

const EndingPage = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-[70px] w-[100vw] h-[100vh] text-white bg-main">
      <div className="w-[1000px] font-medium text-[30px] text-center leading-[50px] tracking-[8px]">
        Foods are not just foods, <br /> they represent the pride and <br />{" "}
        interesting culture of the special country.
      </div>
    </div>
  );
};

export default EndingPage;
